// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { Prescription } from '../_models/prescription.model';
// Models
import { QueryParamsModel } from '../../_base/crud';

export enum PrescriptionActionTypes {
  AllPrescriptionsRequested = '[Prescriptions] All Prescriptions Requested',
  AllPrescriptionsLoaded = '[Prescriptions] All Prescriptions Loaded',
  PrescriptionOnServerCreated = '[Prescriptions] Prescription On Server Created',
  PrescriptionCreated = '[Prescriptions] Prescription Created',
  PrescriptionOnServerUpdated = '[Prescriptions] Prescription On Server Updated',
  PrescriptionUpdated = '[Prescriptions] Prescription Updated',
  PrescriptionOnServerDeleted = '[Prescriptions] Prescription On Server Deleted',
  PrescriptionDeleted = '[Prescriptions] Prescription Deleted',
  PrescriptionsPageRequested = '[Prescriptions] Prescriptions Page Requested',
  PrescriptionsPageLoaded = '[Prescriptions] Prescriptions Page Loaded',
  PrescriptionsPageCancelled = '[Prescriptions] Prescriptions Page Cancelled',
  PrescriptionsPageToggleLoading = '[Prescriptions] Prescriptions Page Toggle Loading',
  PrescriptionsActionToggleLoading = '[Prescriptions] Prescriptions Action Toggle Loading',
  ThrowPrescriptionError = '[Prescriptions] Throw Error',
  FirePrescriptionSuccess = '[Prescriptions] Fire Success',
  ClearPrescriptionState = '[Prescriptions] Clear Prescription Insurance State',
}

export class PrescriptionOnServerCreated implements Action {
  readonly type = PrescriptionActionTypes.PrescriptionOnServerCreated;
  constructor(public payload: { prescription: Prescription; patientId: number }) {}
}

export class PrescriptionCreated implements Action {
  readonly type = PrescriptionActionTypes.PrescriptionCreated;
  constructor(public payload: { prescription: Prescription }) {}
}

export class ThrowPrescriptionError implements Action {
  readonly type = PrescriptionActionTypes.ThrowPrescriptionError;
  constructor(public payload: { error: any }) {}
}

export class FirePrescriptionSuccess implements Action {
  readonly type = PrescriptionActionTypes.FirePrescriptionSuccess;
  constructor(public payload: { action_type: string }) {}
}

export class PrescriptionOnServerUpdated implements Action {
  readonly type = PrescriptionActionTypes.PrescriptionOnServerUpdated;
  constructor(
    public payload: {
      partialPrescription: Update<Prescription>;
      prescription: Prescription;
      patientId: number;
    },
  ) {}
}
export class PrescriptionUpdated implements Action {
  readonly type = PrescriptionActionTypes.PrescriptionUpdated;
  constructor(
    public payload: {
      partialPrescription: Update<Prescription>;
      prescription: Prescription;
    },
  ) {}
}

export class PrescriptionOnServerDeleted implements Action {
  readonly type = PrescriptionActionTypes.PrescriptionOnServerDeleted;
  constructor(public payload: { id: number; patientId: number }) {}
}

export class PrescriptionDeleted implements Action {
  readonly type = PrescriptionActionTypes.PrescriptionDeleted;
  constructor(public payload: { id: number }) {}
}

export class PrescriptionsPageRequested implements Action {
  readonly type = PrescriptionActionTypes.PrescriptionsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class PrescriptionsPageLoaded implements Action {
  readonly type = PrescriptionActionTypes.PrescriptionsPageLoaded;
  constructor(
    public payload: { prescriptions: Prescription[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class PrescriptionsPageCancelled implements Action {
  readonly type = PrescriptionActionTypes.PrescriptionsPageCancelled;
}

export class PrescriptionsPageToggleLoading implements Action {
  readonly type = PrescriptionActionTypes.PrescriptionsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class PrescriptionsActionToggleLoading implements Action {
  readonly type = PrescriptionActionTypes.PrescriptionsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ClearPrescriptionState implements Action {
  readonly type = PrescriptionActionTypes.ClearPrescriptionState;
}

export type PrescriptionActions =
  | PrescriptionCreated
  | PrescriptionUpdated
  | PrescriptionDeleted
  | PrescriptionOnServerCreated
  | PrescriptionOnServerUpdated
  | PrescriptionOnServerDeleted
  | PrescriptionsPageLoaded
  | PrescriptionsPageCancelled
  | PrescriptionsPageToggleLoading
  | PrescriptionsPageRequested
  | ThrowPrescriptionError
  | FirePrescriptionSuccess
  | PrescriptionsActionToggleLoading
  | ClearPrescriptionState;
